import styled from 'styled-components';

export const StyledBadgeRow = styled.div`
    position: absolute;
    top: 4px;
    right: 4px;
    z-index: 1000;
    display: flex;
    gap: 4px;
`;

export const StyledBadge = styled.button<{ $bg: string; $text: string }>`
    display: flex;
    align-items: center;
    gap: 2px;
    padding: 2px 6px;
    border: none;
    border-radius: 10px;
    cursor: pointer;
    background-color: ${({ $bg }) => $bg};
    color: ${({ $text }) => $text};
    font-size: 12px;
    line-height: 1;
    font-weight: 600;
`;
